export enum ShippingType {
    QUOTATION = "QUOTATION",
    ORDER = "ORDER",
}